import React, { FC } from 'react';
import AmplienceDynamicComponent from '../dynamic-component';
export interface AmpliencePageProps {
  pageContent: {
    pageData: [any];
  };
  seo?: {
    title?: string;
    metaDescription?: string;
    canonicalUrl?: string;
  };
  [key: string]: any;
}

const AmpliencePage: FC<AmpliencePageProps> = (props) => {
  const { pageContent, ...restProps } = props;

  return (
    <>
      {pageContent?.pageData?.map((component, index) => {
        if (restProps.isPLP) {
          return (
            <AmplienceDynamicComponent key={'page-content-component-' + index} data={{ ...component }} {...restProps} />
          );
        }
        return <AmplienceDynamicComponent key={'page-content-component-' + index} data={{ ...component }} />;
      })}
    </>
  );
};

export default AmpliencePage;
